import { claimsApi } from '../../../data/claimsApi';
import type { ClaimQueueItemView, ClaimStatus, ClaimView } from '../../../data/views';

/**
 * Queue feature endpoints, injected into the single Claims base api.
 *
 * Owns the C1 read surface the UI needs: the single-claim read and the per-center queue list
 * (contract claims-api.md §3). `center` is required by the backend (per-center grid; no
 * All-Centers, spec decision #12); `status` is an optional filter.
 */
export const claimsQueueEndpoints = claimsApi.injectEndpoints({
  endpoints: (builder) => ({
    getClaim: builder.query<ClaimView, string>({
      query: (id) => ({
        url: `/billing-cases/${id}`,
        method: 'GET',
      }),
      providesTags: (result, error, id) => [{ type: 'Claim', id }],
    }),

    listClaims: builder.query<ClaimQueueItemView[], { center: string; status?: ClaimStatus }>({
      query: ({ center, status }) => ({
        url: '/billing-cases',
        method: 'GET',
        params: { center, status },
      }),
      providesTags: (result, error, { center }) => [
        { type: 'ClaimQueue' as const, id: center },
        'ClaimQueue',
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useGetClaimQuery, useListClaimsQuery } = claimsQueueEndpoints;
